import React from 'react';
import PropTypes from 'prop-types';
import { Link, useSearchParams } from 'react-router-dom';

export const ErrorPage = ({
    children,
    code,
    title,
    description,
    backText,
    backPath,
    exception = null
}) => {
    const [searchParams] = useSearchParams();
    const ref = searchParams.get('ref');

    const handleRetry = () => {
        if (ref) {
            window.location.href = `${ref}?ref=${ref}`;
        } else {
            window.location.href = '/';
        }
    };

    return (
        <div className="text-center w-100">
            {children}
            <h1 className="error-code fw-bolder text-dark">{code}</h1>
            <h3 className="error-title fw-bold text-muted">{title}</h3>
            <p
                className="error-description fw-light text-center text-muted"
                dangerouslySetInnerHTML={{ __html: description }}></p>
            {!exception && (
                <Link className="btn btn-lg btn-outline-primary mt-5" to={backPath}>
                    {backText}
                </Link>
            )}
            {!!exception && (
                <React.Fragment>
                    <div className="card mt-3">
                        <div className="card-body bg-dark">
                            <h5 className="exception-code fw-bold text-light">{exception.code}</h5>
                            <p className="exception-message fw-light text-center text-light mb-0">
                                {exception.message}
                            </p>
                        </div>
                    </div>
                    <button onClick={handleRetry} className="btn btn-lg btn-outline-primary mt-3">
                        Retry
                    </button>
                </React.Fragment>
            )}
        </div>
    );
};

ErrorPage.propTypes = {
    code: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    backText: PropTypes.string,
    backPath: PropTypes.string
};

ErrorPage.defaultProps = {
    backText: 'Return to home',
    backPath: '/'
};
